// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer that is used for validating WorkflowAnswerOption in create workflow questionnaire operation.
 * @see #/components/schemas/WorkflowAnswerOptionCreateUpdateRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowAnswerOptionCreateUpdateRequest {
    /**
     * The display text of Workflow-Answer-Option.
     *
     */
    display: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowAnswerOptionCreateUpdateRequest
 */
export namespace WorkflowAnswerOptionCreateUpdateRequest {
    /**
     * WorkflowAnswerOptionCreateUpdateRequest Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The display text of Workflow-Answer-Option.
         * @type string (`dataFormat` is missing)
         */
        display: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowAnswerOptionCreateUpdateRequest DTO
     * Transforms WorkflowAnswerOptionCreateUpdateRequest model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowAnswerOptionCreateUpdateRequest model */
        static toModel(obj: WorkflowAnswerOptionCreateUpdateRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowAnswerOptionCreateUpdateRequest model */
        static toApi(obj: Model): WorkflowAnswerOptionCreateUpdateRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowAnswerOptionCreateUpdateRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
